module.exports = __webpack_public_path__ + "static/media/04 Generali Życie i zdrowie Ogólne Warunki Ubezpieczenia.8b9ed17c.pdf";